// @ts-nocheck

import { SortSelect } from "@legacy/modules/sort-select.module.ts";
import eventBus from "@legacy/modules/event-bus.module.ts";

const errorContainer = document.getElementById("error-message");
if (errorContainer) {
    errorContainer.style.display = "none";

    // Отобразить ошибку
    eventBus.subscribe("update-cart-error", ({ error }) => {
        errorContainer.textContent = error;
        errorContainer.style.display = "block";
        setTimeout(() => {
            errorContainer.style.display = "none";
        }, 5000);
    });
}

const filterTooltipContainer = document.querySelector(
    ".js-filter-tooltip-container",
);
if (filterTooltipContainer instanceof HTMLElement) {
    try {
        const filterTooltip =
            /** @type {HTMLElement} */ document.querySelector(
                ".js-filter-tooltip",
            );

        // Применить фильтры
        const tooltipApplyBtn =
            /** @type {HTMLElement} */ filterTooltip.querySelector(
                ".js-filter-tooltip-apply",
            );
        tooltipApplyBtn.addEventListener("click", () => {
            hideFilterTooltip();
            loadProducts();
        });

        // Закрыть тултип
        const tooltipCloseBtn =
            /** @type {HTMLElement} */ filterTooltip.querySelector(
                ".js-filter-tooltip-close",
            );
        tooltipCloseBtn.addEventListener("click", () => {
            hideFilterTooltip();
        });

        const rootStyle = getComputedStyle(document.documentElement);

        // Показать тултип при нажатии на чекбокс
        document
            .querySelectorAll(".js-filter-list .js-filter-list__item")
            .forEach((listItem) => {
                const checkbox =
                    /** @type {HTMLInputElement} */ listItem.querySelector(
                        'input[type="checkbox"]',
                    );
                checkbox.addEventListener("click", () => {
                    // Не показывать тултип в мобильной версии
                    if (rootStyle.getPropertyValue("--mobile") === "true") {
                        return;
                    }

                    window.addEventListener("resize", hideFilterTooltip);
                    filterTooltipContainer.hidden = false;
                    const parent = getOffsetParent(filterTooltipContainer);
                    const listItemRect = listItem.getBoundingClientRect();
                    const parentRect = parent.getBoundingClientRect();
                    const left = listItemRect.left - parentRect.left;
                    const top = listItemRect.top - parentRect.top;
                    filterTooltipContainer.style.left = left + "px";
                    filterTooltipContainer.style.top = top + "px";
                    filterTooltipContainer.style.width =
                        listItemRect.width + "px";
                    filterTooltipContainer.style.height =
                        listItemRect.height + "px";
                });
            });
    } catch (error) {
        console.error(error);
    }
}

function hideFilterTooltip() {
    if (filterTooltipContainer instanceof HTMLElement) {
        filterTooltipContainer.hidden = true;
        window.removeEventListener("resize", hideFilterTooltip);
    }
}

/**
 * Получить родительский элемент, относительно которого происходит позиционирование.
 * Если такой элемент отсутствует, возвращается documentElement.
 * @param {HTMLElement} el
 * @returns
 */
function getOffsetParent(el) {
    if (el.offsetParent === null) {
        throw new Error("offsetParent === null");
    }
    if (
        el.offsetParent === document.body &&
        window.getComputedStyle(el.offsetParent).position === "static"
    ) {
        return document.documentElement;
    }
    return el.offsetParent;
}

// Обработка выбора минимальной и максимальной цены
/** @type {number} */
let priceMin = NaN;
/** @type {number} */
let priceMax = NaN;
/** @type {Element | null} */
let priceFromInput;
/** @type {Element | null} */
let priceToInput;
const priceFilter = document.querySelector("#price .js-price-range");
if (priceFilter instanceof HTMLElement) {
    priceMin = parseFloat(priceFilter.dataset.priceMin || "");
    priceMax = parseFloat(priceFilter.dataset.priceMax || "");
    priceFromInput = priceFilter.querySelector("input.js-price-from");
    if (priceFromInput) {
        priceFromInput.addEventListener("keydown", priceRangeChangeHandler);
    }
    priceToInput = priceFilter.querySelector("input.js-price-to");
    if (priceToInput) {
        priceToInput.addEventListener("keydown", priceRangeChangeHandler);
    }
}
if (!Number.isFinite(priceMin)) {
    priceMin = 0;
}
if (!Number.isFinite(priceMax)) {
    priceMax = Infinity;
}

function priceRangeChangeHandler(event) {
    if (event.key === "Enter") {
        loadProducts(true);
    }
}

// Обработка нажатия кнопки Применить
const applyButton = document.querySelector(".js-filter-apply");
if (applyButton instanceof HTMLButtonElement) {
    applyButton.addEventListener("click", () => loadProducts());
}

// Обработка нажатия кнопки Сбросить фильтры
const clearButton = document.querySelector(".js-filter-clear");
if (clearButton instanceof HTMLButtonElement) {
    clearButton.addEventListener("click", () => clearFilters());
}

//Загрузка отфильтрованных продуктов
function loadProducts(applyPriceRange = false) {
    const filters = [];
    const urlParams = new URLSearchParams(window.location.search);

    // Поиск
    if (window.location.pathname.includes("search")) {
        const searchQuery = urlParams.get("search");
        filters.push(`search=${searchQuery}`);
    }

    // Бренды
    const brandCheckboxes = document.querySelectorAll(
        '#brands-list input[type="checkbox"]:checked',
    );
    const brandFilterValues = Array.from(brandCheckboxes).map((checkbox) =>
        checkbox instanceof HTMLElement ? checkbox.dataset.id : "",
    );
    brandFilterValues.forEach((value) => {
        if (!value) return;

        filters.push(`brand-filter=${value}`);
    });

    // Производители
    const manufacturerCheckboxes = document.querySelectorAll(
        '#manufacturers-list input[type="checkbox"]:checked',
    );
    const manufacturerFilterValues = Array.from(manufacturerCheckboxes).map(
        (checkbox) =>
            checkbox instanceof HTMLElement ? checkbox.dataset.id : "",
    );
    manufacturerFilterValues.forEach((value) => {
        if (!value) return;

        filters.push(`manufacturer-filter=${value}`);
    });

    // Цена
    if (applyPriceRange) {
        let priceFrom = NaN;
        if (priceFromInput instanceof HTMLInputElement) {
            priceFrom = priceFromInput.valueAsNumber;
        }
        let priceTo = NaN;
        if (priceToInput instanceof HTMLInputElement) {
            priceTo = priceToInput.valueAsNumber;
        }
        priceTo = clamp(priceTo, priceMin, priceMax);
        priceFrom = clamp(priceFrom, priceMin, priceTo);
        if (Number.isFinite(priceFrom)) {
            filters.push(`price-min=${priceFrom.toFixed(2)}`);
        }
        if (Number.isFinite(priceTo)) {
            filters.push(`price-max=${priceTo.toFixed(2)}`);
        }
    }

    // Варианты
    const variantsFilters = document.querySelectorAll(
        ".js-variants-filter-list",
    );
    const keysObj = {};
    variantsFilters.forEach((filter) => {
        if (!(filter instanceof HTMLElement)) {
            return;
        }
        const key = filter.dataset.id;
        const checkboxes = filter.querySelectorAll(
            'input[type="checkbox"]:checked',
        );
        const values = Array.from(checkboxes).map((checkbox) =>
            checkbox instanceof HTMLElement ? checkbox.dataset.id : "",
        );
        if (values.length > 0) {
            keysObj[key] = values;
        }
    });
    if (Object.keys(keysObj).length > 0) {
        filters.push(`keys=${encodeURI(JSON.stringify(keysObj))}`);
    }

    // Пагинация
    if (urlParams.has("page")) {
        filters.push(`page=${urlParams.get("page")}`);
    }
    if (urlParams.has("limit")) {
        filters.push(`limit=${urlParams.get("limit")}`);
    }

    window.location.search = filters.join("&");
}

/**
 * Убрать все query параметры, кроме поиска и пагинации
 */
function clearFilters() {
    const filters = [];
    const urlParams = new URLSearchParams(window.location.search);

    // Поиск
    if (window.location.pathname.includes("search")) {
        const searchQuery = urlParams.get("search");
        filters.push(`search=${searchQuery}`);
    }

    // Пагинация
    if (urlParams.has("page")) {
        filters.push(`page=${urlParams.get("page")}`);
    }
    if (urlParams.has("limit")) {
        filters.push(`limit=${urlParams.get("limit")}`);
    }

    window.location.search = filters.join("&");
}

/**
 * @param {number} value
 * @param {number} min
 * @param {number} max
 */
function clamp(value, min, max) {
    if (value > max) {
        value = max;
    }
    if (value < min) {
        value = min;
    }
    return value;
}

SortSelect(document.querySelector("[data-catalog-sort]"));
